/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import DashboardComponent from '../components/DashboardComponent'

import { castleActions } from '../_actions'
import { messageConstants } from '../_constants'
import { Growl } from 'primereact/growl'


function DashboardContainer({ isError, isLoading, castle, castleSummary, getCastle, getCastleSummary, saveCastle, successMessage }) {
  const growl = useRef()
  useEffect(() => {
    if (successMessage) {
      growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: successMessage })
    }
  }, [successMessage])
  const history = useHistory()
  useEffect(() => {
    if (isError) {
      history.replace('/login')
    }
  })
  return (
    <div className="p-grid pageWrapper">
      <Growl ref={growl} />
      <DashboardComponent
        getCastle={getCastle}
        getCastleSummary={getCastleSummary}
        saveCastle={saveCastle}
        castle={castle}
        castleSummary={castleSummary}
        isLoading={isLoading} />
    </div>
  )
}
const mapStateToProps = state => {
  return {
    castle: state.castle.singleEntry,
    castleSummary: state.castle.summary,
    isLoading: state.castle.isLoading,
    isError: state.castle.isError,
    successMessage: state.castle.successMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCastle: () => dispatch(castleActions.getCastle()),
    getCastleSummary: () => dispatch(castleActions.getCastleSummary()),
    saveCastle: (castle) => dispatch(castleActions.saveCastle(castle))
  }
}
DashboardContainer.propTypes = {
  castle: PropTypes.object,
  castleSummary: PropTypes.object,
  getCastleSummary: PropTypes.func,
  getCastle: PropTypes.func,
  saveCastle: PropTypes.func,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  successMessage: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)
